import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faShoppingCart, faClipboardCheck, faDollarSign } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

const SalesAgentDashboard = () => {
  const [loading, setLoading] = useState(true); // State for loading
  const [customerCount, setCustomerCount] = useState(0);
  const [transactionCount, setTransactionCount] = useState(0);
  const [visitCount, setVisitCount] = useState(0); // New state for visit count
  const [visits, setVisits] = useState([]); // State to store visit data
  const [successRate, setSuccessRate] = useState(0); // State for success rate

  const user = JSON.parse(localStorage.getItem('user'));
  const name = user.firstName;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Start loading

      const user = JSON.parse(localStorage.getItem('user')); // Extract user details
      if (user && user.email)  {
        try {
          // Fetch customer, transaction and visit data
          const response = await fetch('https://citi-mobile-app.onrender.com/saleagent/totalnumbers', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({ email: user.email })
          });

          if (response.ok) {
            const data = await response.json();
            setCustomerCount(data.customerCount); // Set customer count
            setTransactionCount(data.transactionCount); // Set transaction count
            setVisitCount(data.visitCount); // Set visit count

            // Safeguard: Handle undefined visits by defaulting to an empty array
            setVisits(data.visits); // Set visit data, default to empty array if undefined
            setSuccessRate(data.successRate); // Set success rate
          } else {
            console.error('Failed to fetch agent data');
          }
        } catch (error) {
          console.error('Error:', error);
        }
      }
      setLoading(false); // Stop loading
    };

    
    const sms = async () => {

    // Send the SMS using axios
    const response = await fetch('https://citi-mobile-app.onrender.com/saleagent/sms', {
      method: 'POST',
    });

    // Log the response for debugging
    console.log('Response:', response.data);
  }


  sms();
    fetchData(); // Fetch customer, transaction and visit count
  }, []);

  return (
    <div className="p-4 md:p-6 ml-0 md:ml-60 max-sm:mt-16">
      {/* Card Section */}
      <h1 className="text-xl md:text-2xl lg:text-3xl text-[#1E1E1E] font-bold mb-8 md:mb-16">
        Welcome back {name}
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6">
        {/* Total Customers */}
        <div className="bg-white p-4 rounded-lg shadow-md flex flex-col justify-between">
          <div className="flex items-center justify-between">
            <h2 className="text-sm font-semibold text-gray-600">Total Customers</h2>
            <FontAwesomeIcon icon={faUsers} className="text-blue-500" />
          </div>
          <div className="text-2xl md:text-3xl font-bold mt-4">
            {loading ? <LoadingSpinner /> : customerCount}
          </div>
        </div>

        {/* Total Orders */}
        <div className="bg-white p-4 rounded-lg shadow-md flex flex-col justify-between">
          <div className="flex items-center justify-between">
            <h2 className="text-sm font-semibold text-gray-600">Total Orders</h2>
            <FontAwesomeIcon icon={faShoppingCart} className="text-blue-500" />
          </div>
          <div className="text-2xl md:text-3xl font-bold mt-4">
            {loading ? <LoadingSpinner /> : transactionCount}
          </div>
        </div>

        {/* Visit Success Rate */}
        <div className="bg-white p-4 rounded-lg shadow-md flex flex-col justify-between">
          <div className="flex items-center justify-between">
            <h2 className="text-sm font-semibold text-gray-600">Visit Success Rate</h2>
            <FontAwesomeIcon icon={faClipboardCheck} className="text-blue-500" />
          </div>
          <div className="text-2xl md:text-3xl font-bold mt-4">{successRate}</div>
        </div>

        {/* Customers To Visit */}
        <div className="bg-white p-4 rounded-lg shadow-md flex flex-col justify-between">
          <div className="flex items-center justify-between">
            <h2 className="text-sm font-semibold text-gray-600">Customers To Visit</h2>
            <FontAwesomeIcon icon={faDollarSign} className="text-blue-500" />
          </div>
          <div className="text-2xl md:text-3xl font-bold mt-4">
            {loading ? <LoadingSpinner /> : visitCount}
          </div>
        </div>
      </div>

      {/* Table Section */}
      <h2 className="text-lg font-semibold text-gray-600 mt-8 mb-4">Visit Details</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200">
          <thead>
            <tr>
              <th className="px-4 py-2 border-b-2 border-gray-200">Customer Name</th>
              <th className="px-4 py-2 border-b-2 border-gray-200">Sales Agent</th>
              <th className="px-4 py-2 border-b-2 border-gray-200">Days of Visit</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="3" className="text-center py-4">
                  <LoadingSpinner />
                </td>
              </tr>
            ) : visits.length > 0 ? (
              visits.map(visit => (
                <tr key={visit._id}>
                  <td className="px-4 py-2 border-b border-gray-200">{visit.firstName} {visit.lastName}</td>
                  <td className="px-4 py-2 border-b border-gray-200">{visit.fieldagent}</td>
                  <td className="px-4 py-2 border-b border-gray-200">
                    {visit.customervisitdays}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center py-4">
                  No visits found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// Loading Spinner Component
const LoadingSpinner = () => (
  <div className="flex items-center justify-center">
    <svg
      className="animate-spin h-5 w-5 text-gray-400"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v8H4z"
      ></path>
    </svg>
  </div>
);

export default SalesAgentDashboard;